'use strict'

var _ = require('lodash')
var App = require('app')
var Marionette = require('marionette')
var Backbone = require('backbone')

var Tabs = require('src/behaviors/tabs')

var View = require('./view.js')
var DialogModel = require('src/common/dialog-model.js')

var Emergency = function (options) {
  var Controller = Marionette.Object.extend({
    initialize: function (options) {
      var self = this
      this.region = options.region

      var emergencyModel = App.globalChannel.request('emergency:entity:new')
      console.log('emergency')
      console.log(emergencyModel)
    //  var EmergencyModel = Backbone.Model.extend({})
    //  var emergencyModel = new EmergencyModel()

      // define the dialog model
      var dialogModel = new DialogModel({
        title: 'Emergency mode',
        buttons: {
          left: [],
          right: [
            // { label: 'disable', slug: 'disable', action: 'disable:emergency', roles: ['super', 'admin'] },
            { label: 'activate', primary: true, slug: 'activate', action: 'dialog:submit', roles: ['super', 'admin'] }
          ]
        }
      })

      //
      // this.view = this.getView(emergencyModel)
      this.view = this.getView(dialogModel, emergencyModel)

      this.view.on('render', function () {})

      // temporary
      // 'click .js-color-ring-1': 'realtime:ring_1:change',
      // 'click .js-color-ring-2': 'realtime:ring_2:change'
      this.listenTo(this.view, 'dialog:submit', this.formSubmit)
      this.listenTo(this.view, 'disable:emergency', this.disableEmergencyMode)

      // this.view.on('dialog:submit', _.bind(this.formSubmit, this))
      // this.view.on('disable:emergency', _.bind(this.disableEmergencyMode, this))
      this.view.on('tab:switch', function (tab) {
        self.view.trigger('tab:switch', {'test': 'ok'})
      })

      this.region.show(this.view)
    },
    callEmergencyMode: function (body, callback) {
      var request = new XMLHttpRequest()
      request.open('POST', App.config.api.host + '/emergencies', true)

      request.onload = function () {
        if (request.status >= 200 && request.status < 400) {
          // Success!
          var resp = JSON.parse(request.responseText)
          callback(null, resp)
        } else {
          var resp = JSON.parse(request.responseText)
          callback(resp)
          // We reached our target server, but it returned an error
        }
      }

      request.onerror = function () {
        // There was a connection error of some sort
      }
      request.setRequestHeader('content-type', 'application/json')
      request.send(JSON.stringify(body))
    },
    disableEmergencyMode: function (args) {
      var self = this
      var model = args.model
      var data = Backbone.Syphon.serialize(args.view)

      //
      var emergencyOptions = {
        'enable': 0
      }

      this.callEmergencyMode(emergencyOptions, function (err, data) {
        var data = JSON.parse(data)
        App.dialog.alert('Emergency mode deactivated')
      })

      self.region.empty()
    },
    formSubmit: function (view) {
      var self = this
      var model = view.model
      var data = Backbone.Syphon.serialize(view)

      // when radius or duration isn't set
      if (!data.radius) {
        console.log(data.radius)
        App.dialog.alert('Could not activate emergency mode, radius or duration missing')
      }

      // add one hour to the data.duration as a hacky solution
      // to the timezone
      data.duration = parseInt(data.duration) + 3600;
      //
      // var emergencyOptions = {
      //   'location': model.get('location'),
      //   'radius': data.radius,
      //   'duration': data.duration,
      //   'enable': 1
      // }

      model.set()

      // simple user notification if it takes longer than expected
      var notifyUser = function () {
        App.dialog.alert('Activating emergency mode...')
      }
      var notifyUserTimer = setTimeout(() => notifyUser(), 300)

      model.save({
        'radius': data.radius,
        'duration': data.duration,
        'enable': 1
      }, {
        error: function (model, response) {
          clearTimeout(notifyUserTimer)
          return App.dialog.alert(response.responseJSON.message)
        },
        success: function (model, response) {
          clearTimeout(notifyUserTimer)
          App.dialog.alert('Emergency mode activated on ' + response.nrOfTargetedDevices + ' devices')
        }
      })

      self.region.empty()
    },
    getView: function (dialogModel, model) {
      return new View.Layout({
        dialogModel: dialogModel,
        model: model
      })
    }
  })

  return new Controller(options)
}

module.exports = Emergency



// WEBPACK FOOTER //
// ./js/modules/devices/emergency/index.js